export function initGalleryLightbox() {
  const triggers = Array.from(document.querySelectorAll("[data-lightbox-trigger]"));
  const lightbox = document.querySelector("[data-lightbox]");
  if (!triggers.length || !lightbox) return;

  const imgEl = lightbox.querySelector("[data-lightbox-image]");
  const titleEl = lightbox.querySelector("[data-lightbox-title]");
  const descEl = lightbox.querySelector("[data-lightbox-description]");
  const metaEl = lightbox.querySelector("[data-lightbox-meta]");
  const closeBtn = lightbox.querySelector("[data-lightbox-close]");
  let currentIndex = 0;
  let lastFocused = null;

  function populate(trigger) {
    const { full, alt, title, description, category, date, camera, lens, settings } =
      trigger.dataset;
    imgEl.src = full;
    imgEl.alt = alt || "";
    titleEl.textContent = title || "";
    descEl.innerHTML = description || "";
    metaEl.innerHTML = "";

    const rows = [
      ["Category", category],
      ["Date", date],
      ["Camera", camera],
      ["Lens", lens],
      ["Settings", settings],
    ].filter(([, v]) => v);

    rows.forEach(([label, value]) => {
      const dt = document.createElement("dt");
      dt.textContent = label;
      const dd = document.createElement("dd");
      dd.textContent = value;
      metaEl.append(dt, dd);
    });
  }

  function open(index) {
    currentIndex = index;
    lastFocused = document.activeElement;
    populate(triggers[index]);
    lightbox.setAttribute("data-open", "true");
    lightbox.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
    closeBtn.focus();
  }

  function close() {
    lightbox.setAttribute("data-open", "false");
    lightbox.setAttribute("hidden", "");
    document.body.style.overflow = "";
    lastFocused?.focus();
  }

  triggers.forEach((trigger, index) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      open(index);
    });
  });

  closeBtn.addEventListener("click", close);

  lightbox.addEventListener("click", (e) => {
    if (e.target === lightbox) close();
  });

  document.addEventListener("keydown", (e) => {
    if (lightbox.getAttribute("data-open") !== "true") return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowRight") open((currentIndex + 1) % triggers.length);
    if (e.key === "ArrowLeft") open((currentIndex - 1 + triggers.length) % triggers.length);
  });

  // ---------------------------------------------------------------------
  // Category filters
  // ---------------------------------------------------------------------
  const filterButtons = Array.from(document.querySelectorAll("[data-gallery-filter]"));
  const items = Array.from(document.querySelectorAll("[data-gallery-item]"));

  filterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const category = btn.dataset.galleryFilter;
      filterButtons.forEach((b) => b.setAttribute("aria-pressed", String(b === btn)));

      items.forEach((item) => {
        const match = category === "all" || item.dataset.category === category;
        item.hidden = !match;
      });

      const liveRegion = document.querySelector("[data-gallery-live]");
      if (liveRegion) {
        const visibleCount = items.filter((i) => !i.hidden).length;
        liveRegion.textContent = `Showing ${visibleCount} photo${visibleCount === 1 ? "" : "s"}${
          category === "all" ? "" : ` in ${category}`
        }.`;
      }
    });
  });
}
